/**
 * Builds the `s` parameter the @nestjsx/crud backend expects.
 *
 * A bare string is rejected with 400 "Invalid search param. JSON expected", and the failure is
 * invisible from the UI: the request errors, the query yields nothing, and the page simply
 * looks empty. `$contL` is the backend's case-insensitive contains.
 *
 * Mirrors what @restavo/crud's useCrudResource does, so the pages that migrate to that layer
 * keep identical search behaviour.
 */
export function buildCrudSearch(term: string | null | undefined, fields: string[]): string | undefined {
  const trimmed = term?.trim();
  if (!trimmed || fields.length === 0) {
    return undefined;
  }
  return JSON.stringify({ $or: fields.map((field) => ({ [field]: { $contL: trimmed } })) });
}
